import type { IconData } from '@stacksjs/iconify-core'

export const otherArrowsMerge: IconData = {
  "body": "<path fill=\"currentColor\" d=\"m2 6l6-6l6 6h-4v1l4 4v5h-4v-3.5l-2-2l-2 2V16H2v-5l4-4V6z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default otherArrowsMerge
